// extracted by mini-css-extract-plugin
export var addToCartButton = "_mg-b";
export var arrowButtonContainer = "_mg-9";
export var arrowButtonIcon = "_mg-a";
export var carouselArrowButton = "_mg-6";
export var carouselElementContainer = "_mg-1";
export var left = "_mg-7";
export var productDisplayCarouselContainer = "_mg-0";
export var productTileContainer = "_mg-2";
export var productTileImage = "_mg-4";
export var productTileImageContainer = "_mg-3";
export var productTileTitle = "_mg-5";
export var right = "_mg-8";
export var sliderOverflow = "_mg-c";